import { render, staticRenderFns } from "./merchants-Manage.vue?vue&type=template&id=fb2e6f4c&scoped=true&"
import script from "./merchants-Manage.vue?vue&type=script&lang=js&"
export * from "./merchants-Manage.vue?vue&type=script&lang=js&"
import style0 from "./merchants-Manage.vue?vue&type=style&index=0&id=fb2e6f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2e6f4c",
  null
  
)

export default component.exports